<template>
    <div class="columns">
        <div class="column">
            <div class="columns">
                <router-link class="is-size-7 color-2aabe1" to="/users"><i class="fas fa-arrow-left"></i> BACK TO USERS
                </router-link>
            </div>
            <div class="level">
                <div class="level-left">
                    <div class="title">Invite a new user</div>
                </div>
            </div>
            <div class="is-12">
                <h6 class="subtitle is-6">Enter the details of the user you would like to add to <span
                        class="has-text-weight-bold">{{ org_name }}</span></h6>
            </div>
            <div class="column"></div>
            <div class="is-12">
                <form novalidate @submit.prevent="submitForm">
                    <div class="level">
                        <div class="column is-6-desktop padding-left-0">
                            <div class="field">
                                <div class="control">
                                    <input class="input" type="text" value="" name="email" v-model="form.email"
                                           placeholder="Email address">
                                </div>
                            </div>
                            <div class="column"></div>
                            <div class="field">
                                <label class="label">Type of User</label>
                                <div class="columns is-marginless is-mobile">
                                    <div class="column is-narrow column-checkbox">
                                        <input type="radio" name="role_id" v-model.number="form.role_id" value="3"
                                               checked>
                                    </div>
                                    <div class="column column-checkbox">
                                        <span class="has-text-weight-bold">User</span>
                                        <p class="label is-size-7 has-text-weight-normal">Can manage reviews</p>
                                    </div>
                                </div>
                                <div class="columns is-marginless is-mobile">
                                    <div class="column is-narrow column-checkbox">
                                        <input type="radio" name="role_id" v-model.number="form.role_id" value="2">
                                    </div>
                                    <div class="column column-checkbox">
                                        <span class="has-text-weight-bold">Admin</span>
                                        <p class="label is-size-7 has-text-weight-normal">Has full access, including
                                            user management, billing and all reports</p>
                                    </div>
                                </div>
                                <div class="column"></div>
                                <div class="column is-pulled-right is-10-desktop is-10-widescreen is-10-mobile is-6-tablet">
                                    <div class="buttons">
                                        <button class="button is-button-blue-outline is-button-large margin-right-10"
                                                :disabled="sending" type="reset" @click="cancel">CANCEL
                                        </button>
                                        <button type="submit"
                                                :class="[{ 'is-loading': sending}, 'button is-button-blue is-button-large']"
                                                :disabled="sending">INVITE USER
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>
<script>
  /* eslint-disable indent,no-new,no-undef */
  import ApiResource from '../../api/ApiResource'

  export default {
    metaInfo: {
      title: 'Business Portal | Hellopeter - Invite User'
    },
    mounted () {
      this.$gtm.trackEvent({
        event: 'pageLoad',
        virtualPageUrl: this.$router.currentRoute.path,
        virtualPageTitle: 'Invite User'
      })
    },
    props: ['id'],
    data () {
      return {
        sending: false,
        fetching: true,
        success_msg: '',
        org_id: localStorage.getItem('org_id'),
        can_invite: localStorage.getItem('can_invite'),
        org_name: localStorage.getItem('org_name'),
        form: new ApiResource({
          email: '',
          role_id: 3
        })
      }
    },
    computed: {
      hasErrors () {
        return this.form.errors.any()
      }
    },
    methods: {
      /**
       * Processes form submission
       * @returns {void}
       */
      submitForm () {
        this.sending = true
        this.success_msg = ''
        this.form.errors.clear()
        this.form.send(`/auth/create-invite`, {
          email: this.form.email,
          role_id: this.form.role_id,
          org_id: this.org_id
        })
            .then((success) => {
              this.sending = false
              this.success_msg = success
              this.form.role_id = 3
              flash(success)
                dataLayer.push({
                    'userMessage': {
                        'messageType': 'success',
                        'messageName': 'Successfully invited user on Invite Business User View',
                        'displayedMessage': success
                    }
                })
              this.$router.push('/users')
            })
            .catch(() => {
              this.sending = false
              flash(this.getErrorMessage(), 'is-danger')
                dataLayer.push({
                    'userMessage': {
                        'messageType': 'error',
                        'messageName': 'Failed to invite user on Invite Business User View',
                        'displayedMessage': this.getErrorMessage()
                    }
                })
            })
      },
      /**
       * Gets error message from api calls
       * @returns {string}
       */
      getErrorMessage () {
        return this.form.errors.getDefaultErrorMessage()
      },
      /**
       * Resets all data properties back to default
       * @returns {void}
       */
      cancel () {
        this.form.email = ''
        this.form.role_id = 3
        this.$router.push('/users')
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/pages/invites/InviteUser.vue